module.exports = __webpack_public_path__ + "img/logo-nav.092f1983.png";